export default __webpack_public_path__ + "static/media/artistPage.56ec3b81.jpg";